// extracted by mini-css-extract-plugin
export default {"propertyOverviewTable":"styles-module--propertyOverviewTable---UyIf","asterisk":"styles-module--asterisk--cctgA"};